module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/img_lp-data__box-subtitle02-f355c182b77f9adcddbbcda55890caf4.png";